import { render, staticRenderFns } from "./unverified_clients.vue?vue&type=template&id=57938433"
import script from "./unverified_clients.vue?vue&type=script&lang=js"
export * from "./unverified_clients.vue?vue&type=script&lang=js"
import style0 from "./unverified_clients.vue?vue&type=style&index=0&id=57938433&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports